import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideApiLoader, showApiLoader } from '../../../../redux/tool-webjam/actions';
import { getMyContacts } from '../../../paymentRequest';
import {
    Button,
    Paper,
    IconButton,
    Checkbox,
    ListItemText,
    ListItemIcon,
    ListItemButton,
    ListItem,
    List,
    Typography,
    InputBase,
    Grid,
    TextField,
    InputAdornment
} from '@mui/material';
import { SEARCH_DELAY_TIME } from '../Utils';
import { usePrevious } from '../../../Utils';
import InputTextField from '../helperComponent/InputField';
import { FEATURE_CUSTOM_PAYMENT } from '../../../../constant';
import SearchInput from '../helperComponent/SearchInput';

function ContactDropMenu(props) {
    const [checked, setChecked] = useState([]);
    const [emailId, setEmailId] = useState({});
    const [existId, setExistId] = useState({});
    const [list, setList] = useState([]);
    const [userSearch, setUserSearch] = useState('');

    const [page, setPage] = useState(0)
    const [pageNo, setPageNo] = useState({
        currentPage: 0,
        nextPage: 0,
        prevPage: 0
    })
    const [isNoResult, setNotResult] = useState(false);

    const [loadMore, setLoadMore] = useState(false)
    const [totalRecord, setTotalRecord] = useState(0)
    const dispatch = useDispatch();

    const { selectedEmail, existingUser } = props;

    const {
        paymentContact
    } = useSelector(state => state[FEATURE_CUSTOM_PAYMENT])


    const handleToggle = (value, id) => () => {

        console.log("handle toggle ", value, id)
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        console.log("currentIndex", currentIndex, newChecked, checked)

        if (currentIndex === -1) {
            console.log("if case")
            // console.log("first push",emailId)
            setEmailId({
                ...emailId,
                [value]: id
            })
            newChecked.push(value);
        } else {
            console.log("else case")
            if (emailId[value] != undefined) {
                let ids = emailId;

                console.log("before delete all  ", ids, "value ", ids[value])
                if (ids[value] != undefined) {
                    delete ids[value];
                }
                console.log("after update ", ids)
                selectedEmail(ids)
                setEmailId(ids)
            }
            newChecked.splice(currentIndex, 1);
        }
        setChecked(newChecked);
    };

    const PrevEmailId = usePrevious(emailId);

    useEffect(() => {
        if (PrevEmailId != emailId) {
            selectedEmail(emailId)
        }
    }, [emailId])


    let prevEmail = usePrevious(existingUser)

    useEffect(() => {
        if (existingUser && existingUser.length && prevEmail != existingUser) {
            let emails = [];
            let ids = {};
            existingUser.map(e => {
                emails.push(e.email);
                ids[e.email] = e._id;
            })
            setExistId(ids)
            setEmailId(ids)
            setChecked(emails)
        }
    }, [existingUser])

    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = (data = {}, pagination = "?page=1&limit=10") => {
        dispatch(showApiLoader())

        data = Object.assign({
            search: userSearch
        }, data)

        getMyContacts(data, pagination)
            .then(res => {
                dispatch(hideApiLoader())
                if (res.status == 1) {
                    let data = res.data.data;
                    if (data.contact.length) {
                        setNotResult(false)
                        if (data.pagination.page.currentPage == 1) {
                            setList(data.contact)
                        } else {
                            setList(list.concat(data.contact))
                        }
                        setTotalRecord(data.pagination.count)
                        if (data.pagination.page.nextPage > 0) {
                            setLoadMore(true)
                        } else {
                            setLoadMore(false)
                        }
                        setPageNo(data.pagination.page)
                    } else {
                        setNotResult(true)
                        setList([])
                    }
                }
            })
    }

    const handleLoadMore = () => {
        fetchData('', "?page=" + pageNo.nextPage)
    }

    const handleSearch = (e, isEmpty = false) => {
        setUserSearch(isEmpty ? "" : e?.target?.value)
    }

    let prevSearch = usePrevious(userSearch)
    useEffect(() => {
        if (prevSearch != undefined) {
            var e = setTimeout(() => {
                fetchData();
            }, SEARCH_DELAY_TIME)
            return () => clearTimeout(e)
        }
    }, [userSearch])

    // console.log("existingUser ", existingUser)

    let styles = { p: '2px 4px', mb: 5, mt: 5, display: 'flex', alignItems: 'center', width: 500, background: "none", boxShadow: "none" }

    const { customStyle } = props;
    if (customStyle) {
        styles.mb = customStyle.mb;
        styles.mt = customStyle.mt;
        styles.width = customStyle.width;
        if (customStyle.p != undefined) {
            styles.p = customStyle.p
        }
    }

    return (
        <>
            <Paper
                component="form"
                sx={styles}
            >

                <SearchInput
                    pageSearch={userSearch}
                    handleSearch={handleSearch}
                    classes="w-100"
                    width={props?.width != undefined && props?.width}
                />

            </Paper>

            <Paper style={{ maxHeight: 300, overflow: 'auto' }}>
                <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                    {
                        existingUser && existingUser.length > 0 ?
                            existingUser.map(value => {
                                const _labelId = `checkbox-list-label-${value.email}`;
                                return (
                                    <ListItem
                                        key={value._id}
                                        disablePadding
                                    >
                                        <ListItemButton role={undefined} onClick={handleToggle(value.email, value._id)} dense>
                                            <ListItemIcon>
                                                <Checkbox
                                                    edge="start"
                                                    checked={checked.indexOf(value.email) !== -1}
                                                    tabIndex={-1}
                                                    disableRipple
                                                    inputProps={{ 'aria-labelledby': _labelId }}
                                                />
                                            </ListItemIcon>
                                            <ListItemText id={_labelId} primary={value.email} />
                                        </ListItemButton>
                                    </ListItem>
                                )
                            }) : ''
                    }
                    {list.length ? list.map((value) => {
                        if (existId[value.email] != undefined) return '';

                        const labelId = `checkbox-list-label-${value.email}`;
                        return (
                            <ListItem
                                key={value._id}
                                disablePadding
                            >
                                <ListItemButton role={undefined} onClick={handleToggle(value.email, value._id)} dense>
                                    <ListItemIcon>
                                        <Checkbox
                                            edge="start"
                                            checked={checked.indexOf(value.email) !== -1}
                                            tabIndex={-1}
                                            disableRipple
                                            inputProps={{ 'aria-labelledby': labelId }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText id={labelId} primary={value.email} />
                                </ListItemButton>
                            </ListItem>
                        );
                    }) : (isNoResult && (!existingUser?.length) ?
                        <>
                            <ListItem
                                key={"No_data"}
                            >
                                <ListItemText id={"No_data"} primary={"No data found"} />

                            </ListItem>
                        </>
                        : '')
                    }
                </List>
            </Paper>
            {
                loadMore &&
                <Typography align="center">
                    <Button
                        onClick={() => handleLoadMore()}
                        variant="contained"
                        className="p-theme-btn m-t-20"
                        sx={{
                            fontSize: 14,
                            backgroundColor: "var(--theme-primary-color)",
                        }}
                    >
                        Load More
                    </Button>
                </Typography>
            }
        </>
    );
}

export default ContactDropMenu;
